// Check if the current browser supports performance timing API
export function browserSupportPerfApi(): boolean {
  return (
    window.self.performance != null && window.self.performance.mark != null
  );
}

// Class used to do mark() and measure() in local browser
export class PerformanceMarker {
  browserSupportMark: boolean;

  constructor() {
    this.browserSupportMark = browserSupportPerfApi();
  }

  public mark(markName: string, options?: Record<string, number>) {
    if (this.browserSupportMark) {
      if (options !== undefined) {
        window.self.performance.mark(markName, options);
      } else {
        window.self.performance.mark(markName);
      }
    }
  }

  public measure(
    measureName: string,
    endMarkName: string,
    startMarkName: string
  ) {
    if (this.browserSupportMark) {
      try {
        window.self.performance.measure(
          measureName,
          startMarkName,
          endMarkName
        );
      } catch (e) {
        // If for whatever reasons can't find a paired marks, it's ok to ignore the exception and continue
      }
    }
  }
}
